import type { FaireProductEntity } from "../../entity_types/product";

export const p_n4n8yemuvw: FaireProductEntity = {
  token: "p_n4n8yemuvw",
  type: "product",
  name: "Origin Necklace",
  brandToken: "b_xs4ej7t4ss",
  brandName: "ALCO Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/f26a7b5516d3299b8465009477ddd0b5135d055567a6ca42a9a99f947fdcac29.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d1f6893706ea5e8cc4d40c0b828bc6ed65c5bd2136c1329c4b980d125b1d981.jpeg",
    "https://cdn.faire.com/fastly/ff63777ca8890071931a369fbcad19755054dbc41246063f67846c3aae92dfd5.jpeg",
    "https://cdn.faire.com/fastly/5eb226ba6b89696335d2715aaebadab48b5071570100d4730b63d10e35d6ed82.jpeg",
    "https://cdn.faire.com/fastly/ce7a2c49aa9164f9c2cf59711c6874d04622322bcc27705aa51b849e69fd9979.jpeg",
    "https://cdn.faire.com/fastly/a359a4b4e5970696f50ee117a2873d652e1e605e3dbba5f2d6bbae1f7662e509.jpeg",
    "https://cdn.faire.com/fastly/404a3be2f70e965b2363f8df319507564f3b5ee1c22febde7a30e4118d6060a2.jpeg",
    "https://cdn.faire.com/fastly/58f82f4d3c8e4f073aa4aca472a4b33633cb522d0fc5bcf96a7728bc819046d1.jpeg",
  ],
  priceDollars: 59,
  description:
    'The Origin Necklace brings sculpted gold discs together through softly hammered connection rings, creating natural texture, movement, and balance. This statement gold Y necklace is intentionally formed to feel organic and lived in, with hammered rings that create subtle dimension at every angle. Water resistant, tarnish resistant, and hypoallergenic.\n\n\n\n * 18K Gold-Plated \n * Stainless Steel\n\n * Nickel-Free \n * Lead-Free \n * Hypoallergenic \n * Lobster Clasp \n * 16" Chain \n * 2" Detachable Extender \n * Water Resistant ',
  tags: [],
  msrpDollars: 118,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:00.665Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
